import axios from "../axios";
const END_POINT = "/service-categories";
const addServiceCategories = (serviceCategories) => axios.post(`${END_POINT}`, serviceCategories);
const getServiceCategory = (serviceCategoriesId) => axios.get(`${END_POINT}/${serviceCategoriesId}`);
const getServiceCategories = (payload) => axios.get(`${END_POINT}?limit=${payload.limit}&page=${payload.page}`);
const deleteServiceCategories = (serviceCategoriesId) => axios.delete(`${END_POINT}/${serviceCategoriesId}`);
const searchServiceCategory = (payload) => axios.post(`${END_POINT}/search`, payload);
const updateServiceCategories = (serviceCategoriesId, payload) => axios.patch(`${END_POINT}/${serviceCategoriesId}`, payload);


export {
  getServiceCategories,
  addServiceCategories,
  deleteServiceCategories,
  searchServiceCategory,
  getServiceCategory,
  updateServiceCategories
};
